import { createSlice } from '@reduxjs/toolkit';

const initialAdminDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    firstName: '',
    lastName: '',
    photo: '',
    email: '',
    studios: [],
  },
};

const initialEmployeesDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    firstName: '',
    lastName: '',
    photo: '',
    email: '',
    specialty: '',
    workplaces: [],
  },
};

export const initialServicesDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    image: '',
    title: '',
    duration: 0,
    studio: [],
    priceList: [],
    categories: [],
  },
};

const initialStudioDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    title: '',
    address: '',
    images: [],
    timezone: '',
    schedule: {
      workingTimes: [],
      daysOff: [],
      holidays: [],
    },
    admins: [],
    masters: [],
  },
};

const initialBookingsDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    status: '',
    payed: false,
    paymentType: '',
    from: '',
    price: 0,
    availability: {},

    services: [],
    master: {},
    studio: {},
  },
};

const initialWorkingTimeDialogParams = {
  step: 0,
  maxAvailableStep: 0,
  isEdit: false,
  data: {
    id: '',
    title: '',
    description: '',
    updatedAt: '',
    workingTimes: [],
    daysOff: [],
    holidays: [],
  },
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState: {
    isAdminDialogOpen: false,
    adminDialogParams: initialAdminDialogParams,

    isStudioDialogOpen: false,
    studioDialogParams: initialStudioDialogParams,

    isServicesDialogOpen: false,
    servicesDialogParams: initialServicesDialogParams,

    isEmployeesDialogOpen: false,
    employeesDialogParams: initialEmployeesDialogParams,

    isBookingsDialogOpen: false,
    bookingsDialogParams: initialBookingsDialogParams,

    isWorkingTimeDialogOpen: false,
    workingTimeDialogParams: initialWorkingTimeDialogParams,
  },
  reducers: {
    //ADMIN
    setAdminDialogParams: (state, action) => {
      state.adminDialogParams = action.payload;
    },
    resetAdminDialogParams: state => {
      state.adminDialogParams = initialAdminDialogParams;
    },
    showAdminDialog: state => {
      state.isAdminDialogOpen = true;
    },
    closeAdminDialog: state => {
      state.isAdminDialogOpen = false;
    },
    //STUDIO
    setStudioDialogParams: (state, action) => {
      state.studioDialogParams = action.payload;
    },
    resetStudioDialogParams: state => {
      state.studioDialogParams = initialStudioDialogParams;
    },
    showStudioDialog: state => {
      state.isStudioDialogOpen = true;
    },
    closeStudioDialog: state => {
      state.isStudioDialogOpen = false;
    },
    //SERVICES
    setServicesDialogParams: (state, action) => {
      state.servicesDialogParams = action.payload;
    },
    resetServicesDialogParams: state => {
      state.servicesDialogParams = initialServicesDialogParams;
    },
    showServicesDialog: state => {
      state.isServicesDialogOpen = true;
    },
    closeServicesDialog: state => {
      state.isServicesDialogOpen = false;
    },
    //EMPLOYEES
    setEmployeesDialogParams: (state, action) => {
      state.employeesDialogParams = action.payload;
    },
    resetEmployeesDialogParams: state => {
      state.employeesDialogParams = initialEmployeesDialogParams;
    },
    showEmployeesDialog: state => {
      state.isEmployeesDialogOpen = true;
    },
    closeEmployeesDialog: state => {
      state.isEmployeesDialogOpen = false;
    },
    //BOOKINGS
    setBookingsDialogParams: (state, action) => {
      state.bookingsDialogParams = action.payload;
    },
    resetBookingsDialogParams: state => {
      state.bookingsDialogParams = initialBookingsDialogParams;
    },
    showBookingsDialog: state => {
      state.isBookingsDialogOpen = true;
    },
    closeBookingsDialog: state => {
      state.isBookingsDialogOpen = false;
    },

    //working time
    setWorkingTimeDialogParams: (state, action) => {
      state.workingTimeDialogParams = action.payload;
    },
    resetWorkingTimeDialogParams: state => {
      state.workingTimeDialogParams = initialWorkingTimeDialogParams;
    },
    showWorkingTimeDialog: state => {
      state.isWorkingTimeDialogOpen = true;
    },
    closeWorkingTimeDialog: state => {
      state.isWorkingTimeDialogOpen = false;
    },
  },
});

export const {
  //ADMIN
  setAdminDialogParams,
  resetAdminDialogParams,
  showAdminDialog,
  closeAdminDialog,
  //STUDIO
  setStudioDialogParams,
  resetStudioDialogParams,
  showStudioDialog,
  closeStudioDialog,
  //SERVICES
  setServicesDialogParams,
  resetServicesDialogParams,
  showServicesDialog,
  closeServicesDialog,
  //EMPLOYEES
  setEmployeesDialogParams,
  resetEmployeesDialogParams,
  showEmployeesDialog,
  closeEmployeesDialog,
  //BOOKINGS
  setBookingsDialogParams,
  resetBookingsDialogParams,
  showBookingsDialog,
  closeBookingsDialog,
  // WORKING TIME
  setWorkingTimeDialogParams,
  resetWorkingTimeDialogParams,
  showWorkingTimeDialog,
  closeWorkingTimeDialog,
} = dialogSlice.actions;

export default dialogSlice.reducer;
